import React, {useState, useEffect, Fragment} from 'react';
import { Container, Row, Col, Button, Input, Card, CardBody, Modal, ModalHeader, ModalBody, ModalFooter, CardTitle, FormGroup, Label, Form } from "reactstrap";
import { Link, Redirect, withRouter } from "react-router-dom";
import {Table, Thead, Tbody, Tr, Th, Td} from 'react-super-responsive-table';
import { Pagination, DatePicker } from "antd";
import { paramPost } from "../../apiHelpers/commonApiHelper";
import { CSVLink, CSVDownload } from "react-csv";

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';

import { connect } from 'react-redux';


import { getReportOption, getReport } from '../../store/actions';
import Select from "react-select";
//i18n
import { withNamespaces } from 'react-i18next';
import { AvForm, AvField } from "availity-reactstrap-validation";
import moment from "moment";
import Dropzone from "react-dropzone";
import { Checkbox, Tooltip } from 'antd';
import toastr from "toastr";
import SweetAlert from "react-bootstrap-sweetalert";
import axios from "axios";

const { RangePicker } = DatePicker



const Report = (props) => {

    useEffect(() => {
        props.getReportOption();
        props.getReport({player: player, campaign: campaign, page: current, pageSize: pageSize, startDate: start, endDate: end});
    }, []);

    const [current, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [player, setPlayer] = useState(1);
    const [campaign, setCampaign] = useState(1);

    const [start, setStart] = useState('')
    const [end, setEnd] = useState('')
    const [printing, setPrinting] = useState(false)

    const getDate = (value, dateString) => {
        if (value) {
            setStart(dateString[0])
            setEnd(dateString[1])
        } else {
            setStart('');
            setEnd('');
        }
    }

    const players = () => {
        if(props.players && props.players.length > 0) {
            return props.players.map((item, index) => {
                return (
                    <option key={index} value={item.id + 1}>
                        {item.player_name}
                    </option>
                )
            })
        }
    }

    const campaigns = () => {
        if(props.campaigns && props.campaigns.length > 0) {
            return props.campaigns.map((item, index) => {
                return (
                    <option key={index} value={item.id + 1}>
                        {item.name}
                    </option>
                )
            })
        }
    }

    const handleFindActivity = (event, values) => {
        console.log(values);
        props.getReport({player: values.player, campaign: values.campaign, page: current, pageSize: pageSize, startDate: start, endDate: end})
    }

    function onShowSizeChange(current, pageSize) {
        setPageSize(pageSize)
        setCurrentPage(current)
        props.getReport({player: player, campaign: campaign, page: current, pageSize: pageSize, startDate: start, endDate: end})
    }
    const onChange = (page) => {
        setCurrentPage(page)
        props.getReport({player: player, campaign: campaign, page: page, pageSize: pageSize, startDate: start, endDate: end});
    }

    const csvData = () => {
        if(props.reports && props.reports.length > 0) {
            let data = [
                ['Player Name', 'Campaign Name', 'Date', 'Time', "Status"]
            ]
            props.reports.map((item) => {
                let singleData = [
                    item.player_name,
                    item.campaign_name,
                    moment(item.log_created_at).format('L'),
                    moment(item.log_created_at).format('LTS'),
                    item.status_string
                ];
                data.push(singleData);
            });
            return data;
        }
    }

    const generateReport = () => {
        setPrinting(true);
        const headers = JSON.parse(localStorage.getItem("authHeaders"))
        const config = {
            method: 'post',
            url: `/api/v1/players/generate_pdf`,
            headers: {
                accesstoken: headers.accesstoken,
                client: headers.client,
                uid: headers.uid,
            },
            responseType: 'blob',
            data: {player: player, campaign: campaign, page: current, pageSize: pageSize, startDate: start, endDate: end}
        }
        axios
            .request(config)
            .then(response => {
                setPrinting(false);
                const blob = URL.createObjectURL(response.data);
                window.open(blob, '_blank');
            })
            .catch((err) => {
                setPrinting(false);
                toastr.error("Something went wrong!", "Error")
            });
    }

    const reportList = () => {
        if(props.reports && props.reports.length > 0) {
            return props.reports.map((item, index) => {
                return (
                    <Tr key={index}>
                        <Td>
                            {item.player_name}
                        </Td>
                        <Td>
                            {item.campaign_name}
                        </Td>
                        <Td>
                            {moment(item.log_created_at).format('L')}
                        </Td>
                        <Td>
                            {moment(item.log_created_at).format('LTS')}
                        </Td>
                        <Td>
                            {item.status_string}
                        </Td>
                    </Tr>
                )
            })
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <AvForm className="outer-repeater row m-auto" style={{ width: "100%" }} onValidSubmit={(e, v) => { handleFindActivity(e, v) }}>
                        <Col xs={12} sm={6} md={3}>
                            <div className="form-group">
                                <AvField
                                    label={"Select Player"}
                                    type="select"
                                    name="player"
                                    value={1}
                                    onChange={(e) => setPlayer(e.target.value)}
                                >
                                    <option value={1}>Select All</option>
                                    {players()}
                                </AvField>
                            </div>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                            <div className="form-group">
                                <AvField
                                    type="select"
                                    name="campaign"
                                    label={"Select Campaign"}
                                    value={1}
                                    onChange={(e) => setCampaign(e.target.value)}
                                >
                                    <option value={1}>Select All</option>
                                    {campaigns()}
                                </AvField>
                            </div>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                            <div className="form-group">
                                <label>Select dates</label>
                                <div className="mb-3">
                                    <RangePicker style={{padding: '6px 12px'}} onChange={getDate} />
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} sm={6} md={3}>
                            <FormGroup className="mb-0">
                                <div style={{marginTop: "26px"}}>
                                    <Button type="submit" color="primary" className="mr-1" style={{ width: "100%" }} disabled={props.loading}>
                                        {props.loading ? (
                                            <React.Fragment>
                                                <i className="bx bx-loader bx-spin font-size-16 align-middle mr-2"></i>
                                                Finding
                                            </React.Fragment>
                                        ) : "Find"}
                                    </Button>
                                </div>
                            </FormGroup>
                        </Col>
                    </AvForm>
                    {props.reports && props.reports.length > 0 && (
                    <Row className="mb-3">
                        <Col xs={12} className="report-print-btn">
                            {/*<CSVLink data={csvData()} filename={`report_${moment().format('MM_DD_YYYY_HH_mm_ss')}.csv`}>*/}
                            {/*    <button style={{marginRight: "12px"}} type="button" className="mt-sm-1 float-right btn btn-success waves-effect waves-light w-sm">*/}
                            {/*        <i className="fas fa-file-export d-block font-size-16"></i>*/}
                            {/*        Export to CSV*/}
                            {/*    </button>*/}
                            {/*</CSVLink>*/}
                            {!printing ? (
                                <button style={{marginRight: "12px"}} type="button" className="mt-sm-1 float-right btn btn-success waves-effect waves-light w-sm" onClick={generateReport}>
                                    <i className="fa fa-print d-block font-size-16"></i>
                                    Export to Pdf
                                </button> ) : (
                                <button style={{marginRight: "12px"}} type="button" className="mt-sm-1 float-right btn btn-success waves-effect waves-light w-sm" disabled={true}>
                                    <i className="fa fa-print d-block font-size-16"></i>
                                    <i className="bx bx-loader bx-spin font-size-16 align-middle mr-2"></i>
                                    Generating Report...
                                </button> )}
                        </Col>
                    </Row>
                    )}

                    <div className="table-rep-plugin">
                        <div
                            className="table-responsive mb-0"
                            data-pattern="priority-columns"
                        >
                            <Table
                                id="tech-companies-1"
                                className="table table-striped table-bordered content-table"
                            >
                                <Thead>
                                    <Tr>
                                        <Th data-priority="1">Player Name</Th>
                                        <Th data-priority="1">Campaign Name</Th>
                                        <Th data-priority="1">Date</Th>
                                        <Th data-priority="1">Time</Th>
                                        <Th data-priority="1">Status</Th>
                                    </Tr>
                                </Thead>

                                {!props.loading && (
                                    <Tbody className="">{reportList()}</Tbody>
                                )}
                            </Table>
                            {props.loading && (
                                <div className="loading-icon">
                                    <i className="fas fa-sync fa-spin"></i>
                                </div>
                            )}
                        </div>
                    </div>
                    <Pagination className="float-right" style={{marginRight: "10px"}} current={current} defaultPageSize={20} onShowSizeChange={onShowSizeChange} onChange={onChange} total={props.total ? props.total : 0} />
                </Container>
            </div>
        </React.Fragment>
    );
}

const mapStateToProps = state => {
    const { campaigns, players, total, reports, loading } = state.ReportReducer;
    return { campaigns, players, total, reports, loading };
}

export default withRouter(connect(mapStateToProps, { getReportOption, getReport })(withNamespaces()(Report)));
